import { Note } from "./note.model";
import { RestrictedAccountObjectStoreFacade } from "../restricted-account-object/restricted-account-object.store-facade";
import { Observable } from "rxjs/Observable";
import { Qry } from "../query-facade";
import * as actions from "../note/note.actions";
import { ActionOptionsArgs } from "../../../core/store/actions/base-actions";
import { Job } from "../job/job.model";

export class NoteStoreFacade extends RestrictedAccountObjectStoreFacade<Note> {

    getAll(): Observable<Array<Note>> {
        return this.select(Qry.getInstance().note.byActiveAccount);
    }

    create(note: Note): void {
        this.dispatch(new actions.SubmitAction(note));

        // this.appFacade.objects.job.store.get(note.job).take(1).subscribe(job => {
        //     this.appFacade.objects.job.store.attachNote(job, note);
        // });
    }

    update(note: Note): void {
        this.dispatch(new actions.SubmitAction(note));
    }

    insert(note: Note): void {
        this.dispatch(new actions.SubmitAction(note, {persistable: true, restful: false}));
    }

    remove(note: Note, options?: ActionOptionsArgs): void {
        // this.appFacade.store.job.getAll().take(1).subscribe(jobs => {
        //     jobs.forEach(job => this.appFacade.store.job.detachNote(job, note));
        // });

        this.dispatch(new actions.RemoveAction(note, options));
    }

    getByJob(job: Job): Observable<Array<Note>> {
        return this.getBy(note => note.job === job.id);
    }

    removeByJob(job: Job): void {
        return this.removeBy(note => note.job === job.id);
    }

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/note/note.store-facade.ts